import React from 'react';

import styled from 'styled-components';

import { FormattedMessage } from '@techstyle/react-intl';

const ReturnItHeader = styled.h3`
  ${({ theme }) => theme.subHeader.variants.subHeading3Uppercase.textStyles}
  font-weight: 500;
`;

const Paragraph = styled.p`
  margin: ${({ theme }) => theme.spacing.small}px
    ${({ theme }) => theme.spacing.none}px;
`;

const ReturnsLink = styled.a`
  ${({ theme }) => theme.links.variants.textLinkPrimary}
  color: ${({ theme }) => theme.colors.black};
  border-bottom: 2px solid ${({ theme }) => theme.colors.lavender};
`;

const ReturnInfo: React.FC = () => {
  return (
    <>
      <ReturnItHeader>
        <FormattedMessage
          id="fit_guide.not_the_right_fit"
          defaultMessage="Not the right fit? Return it!"
        />
      </ReturnItHeader>
      <Paragraph>
        <FormattedMessage
          id="fit_guide.return_policy"
          defaultMessage={
            "If the size doesn't work for you, don't worry! You can" +
            ' return your purchase within 30 to 90 days and find a better' +
            ' match. See our policy below for more info.'
          }
        />
      </Paragraph>
      <ReturnsLink
        href="https://help.savagex.com/hc/en-us/sections/360008042292-RETURNS-AND-EXCHANGES"
        data-autotag="returnsAndExchangesLink"
      >
        <FormattedMessage
          id="fit_guide.returns_and_exchanges"
          defaultMessage="Returns and Exchanges"
        />
      </ReturnsLink>
    </>
  );
};

export default ReturnInfo;
